module.exports = __webpack_public_path__ + "static/media/map-pin.f9cc867f.svg";